import { Stack, Tabs, Title } from '@mantine/core'
import { createFileRoute, Outlet, redirect, useLocation } from '@tanstack/react-router'
import { useAccount } from 'hooks/auth'

export const Route = createFileRoute('/_auth/profile')({
  beforeLoad: async ({ location }) => {
    const { pathname } = location
    if (pathname === '/profile' || pathname === '/profile/') {
      //   // TODO: someone might not have access to 'work' section
      throw redirect({ to: 'cutting' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { data: account } = useAccount()
  const navigate = Route.useNavigate()
  const { pathname } = useLocation()
  const section = pathname.split('/').pop()

  return (
    <Stack gap="xl">
      <Title order={1}>Cześć, {account.firstName}!</Title>
      <Tabs value={section} onChange={(value) => navigate({ to: `/profile/${value}` })}>
        <Tabs.List>
          <Tabs.Tab value="cutting">Docinanie</Tabs.Tab>
          <Tabs.Tab value="sewing">Szycie</Tabs.Tab>
          <Tabs.Tab value="eyelet">Przelotki</Tabs.Tab>
          <Tabs.Tab value="shortage">Braki</Tabs.Tab>
        </Tabs.List>
        <Outlet />
      </Tabs>
    </Stack>
  )
}
